module.exports = __webpack_public_path__ + "img/batiment-UQAM.b82d520a.jpg";